import React, { useContext } from 'react'
import L from 'leaflet'
import { CircleMarker, Tooltip } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { GetAllJobs } from '../../../functions/GetAllJobs';
import coordenadas from '../../../functions/coords.json'
import { SearchContext } from '../../search/SearchContext';

export const JobsMarkers = () => {

    const { filters, setFilters } = useContext(SearchContext);
    const { preformat } = GetAllJobs();

    // let ofertasFiltradas = []
    // filterJobs.forEach(job => {
    //     job.locations.forEach(element => {
    //         ofertasFiltradas.push(element.city.name);
    //     });
    // });


    const comunas = coordenadas.map((e) => {

        let result = preformat.filter(comuna => comuna === e.nombre).length
        return {
            ...e,
            trabajos: result
        }
    })

    const ofertaslaborales = comunas.filter(c => c.trabajos > 0);
    const createClusterCustomIcon = function (cluster) {
        var childs = cluster.getAllChildMarkers();
        var numbers = 0;
        childs.forEach(element => {
            if (element._tooltip.options.className.includes("map-label")) {
                numbers = numbers + parseInt(element._tooltip.options.children)
            }
        });
        return L.divIcon({
            html: `<span>${numbers}</span>`,
            className: 'map-group',
            iconSize: L.point(40, 40, true),
        });
    }

    const handleClick = (e) => {
        const result = e.sourceTarget.options.comuna;
        setFilters({ ...filters, locations: [result], page: 0 });
    }


    return (
        <MarkerClusterGroup iconCreateFunction={createClusterCustomIcon} showCoverageOnHover={false}>
            {
                ofertaslaborales.map((oferta, i) => {
                    return <CircleMarker key={i} center={[oferta.latitud, oferta.longitud]} radius={15} opacity={0.2} fillOpacity={0.7} color="#f1630d" eventHandlers={{ click: handleClick }} comuna={oferta.nombre}>
                        <Tooltip className="map-label" direction="top" offset={[0, 10]} opacity={1} permanent>
                            {oferta.trabajos}
                        </Tooltip>
                    </CircleMarker>
                })
            }
        </MarkerClusterGroup>
    )
}
